<div class="wrapper">
  <div class="header">
    <ng-content></ng-content>
  </div>
  <div class="body">
    <div class="bodyTitle"></div>
    <div class="frame">
      <span class="frameHeader" i18n="@@general.remarks">Remarks</span>
      <span>{{ remarks }}</span>
    </div>
  </div>
</div>
